<template>
  <el-popover
    placement="bottom-end"
    :width="107"
    trigger="click"
    v-model:visible="visible"
    popper-class="hotelux-currency-selector-popper"
  >
    <div class="currency-list">
      <button
        type="button"
        class="currency-item"
        v-for="(item, index) in currencyList"
        :key="index"
        :class="{ active: item.value === modelValue }"
        @click="handleCurrencyChange(item.value)"
      >
        <UIText>{{ item.label }}</UIText>
        <font-icon v-if="item.value === modelValue" icon="icon-gou" />
      </button>
    </div>
    <template #reference>
      <button
        type="button"
        class="hotelux-currency-selector"
        :aria-expanded="visible"
      >
        <font-icon
          icon="icon-hotelux-Exchange"
          class="icon-hotelux currency-icon"
        />
        <UIText class="current-currency">{{ currentCurrencyLabel }}</UIText>
        <font-icon
          class="icon-hotelux arrow-icon"
          icon="icon-hotelux-Arrow_Down"
          :class="{ open: visible }"
        />
      </button>
    </template>
  </el-popover>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import UIText from "../UiText/index.vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "USD"
  }
});

const emit = defineEmits(["update:modelValue", "change"]);

const { t } = useI18n();

const currencyList = computed(() => [
  {
    label: t("shared.hotel.currencyList.local"),
    value: "local"
  },
  {
    label: t("shared.hotel.currencyList.USD"),
    value: "USD"
  },
  {
    label: t("shared.hotel.currencyList.CNY"),
    value: "CNY"
  },
  {
    label: t("shared.hotel.currencyList.SGD"),
    value: "SGD"
  },
  {
    label: t("shared.hotel.currencyList.HKD"),
    value: "HKD"
  },
  {
    label: t("shared.hotel.currencyList.THB"),
    value: "THB"
  },
  {
    label: t("shared.hotel.currencyList.AUD"),
    value: "AUD"
  },
  {
    label: t("shared.hotel.currencyList.EUR"),
    value: "EUR"
  },
  {
    label: t("shared.hotel.currencyList.JPY"),
    value: "JPY"
  },
  {
    label: t("shared.hotel.currencyList.TWD"),
    value: "TWD"
  },
  {
    label: t("shared.hotel.currencyList.MYR"),
    value: "MYR"
  },
  {
    label: t("shared.hotel.currencyList.RUB"),
    value: "RUB"
  }
]);

const visible = ref(false);

const currentCurrencyLabel = computed(() => {
  return (
    currencyList.value.find(item => item.value === props.modelValue)?.label ??
    ""
  );
});

const handleCurrencyChange = value => {
  emit("update:modelValue", value);
  emit("change", value);
  visible.value = false;
};

defineOptions({
  name: "HoteluxCurrencySelector"
});
</script>

<style lang="scss" scoped>
.hotelux-currency-selector {
  display: flex;
  align-items: center;
  padding: 0;
  color: inherit;
  cursor: pointer;
  background: transparent;
  border: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
}

.currency-icon {
  font-size: 20px;
}

.current-currency {
  // font-family: Lato, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  margin-left: 6px;
  white-space: nowrap;
}

.arrow-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 20px;
  margin-left: 6px;
  transition: transform 0.3s ease;

  &.open {
    transform: rotate(180deg);
  }
}

.currency-list {
  padding: 8px 0;

  .currency-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 16px;
    // font-family: Lato, -apple-system, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #757575;
    line-height: 1;
    text-align: left;
    cursor: pointer;
    background: transparent;
    border: 0;
    transition: all 0.2s ease;

    &:hover {
      color: #212223;
      background: #f8f8f8;
    }

    &.active {
      color: #212223;
      font-weight: 500;
    }

    .icon-gou {
      font-size: 12px;
      color: #212223;
    }
  }
}
</style>

<style>
.el-popper.hotelux-currency-selector-popper {
  border: 0;
  border-radius: 0;
  box-shadow: 0 2px 8px rgb(0 0 0 / 8%);
  padding: 0;
}

.el-popper.hotelux-currency-selector-popper .el-popper__arrow {
  display: none;
}
</style>
